module.exports = __webpack_public_path__ + "assets/img/7.accb302a.png";